<template>
  <div class="assessment-help-container" v-if="showAssessmentHelpBtn" transition="fade-05">
    <a class="assessment-help-button"
      @click.stop.prevent="activityHelpLink"
      v-html='btnAssessment'
    ></a>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ErrorLogger from 'mixins/ErrorLogger';
import InactivityHelper from 'mixins/InactivityHelper';
import btnAssessment from 'assets/svg/assessment-question-mark.svg';

export default {
  mixins: [ErrorLogger, InactivityHelper],

  computed: {
    ...mapState('activity', ['showAssessmentHelpBtn'])
  },

  data() {
    return {
      btnAssessment
    };
  },

  methods: {
    activityHelpLink() {
      // force stop/save errorlogger data even though they're not actually finished.
      this.errorLoggerStop();
      this.playHelpSnd();
      this.$router.replace({ path: '/assessment-help', params: {} });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/sass/fade.scss";
</style>
